import { Divider, Grid2, Skeleton } from "@mui/material"
import { memo } from "react"

const OrderManageSkeleton = memo(({ inSystem = false }: { inSystem?: boolean }) => {
    return (
        <Grid2 container size={'grow'} flexDirection={'column'} spacing={2}>
            <Grid2 container justifyContent={'space-between'} display={inSystem? 'none' : 'flex'}>
                <Grid2 width={{ xs: 75, md: 200 }}>
                    <Skeleton variant="rounded" width={'100%'} height={40} />
                </Grid2>
                <Grid2>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid2>
            </Grid2>
            <Grid2 container padding={2} display={'flex'} alignItems={'center'}>
                <Grid2 container>
                    <Grid2>
                        <Skeleton variant="circular" width={40} height={40} />
                    </Grid2>
                    <Grid2 width={{ xs: 75, md: 200 }}>
                        <Skeleton variant="rounded" width={'100%'} height={40} />
                    </Grid2>
                </Grid2>
                <Grid2 size={'grow'}>
                    <Skeleton variant="rounded" width={'100%'} height={2} />
                </Grid2>
                <Grid2 container>
                    <Grid2>
                        <Skeleton variant="circular" width={40} height={40} />
                    </Grid2>
                    <Grid2 width={{ xs: 75, md: 200 }}>
                        <Skeleton variant="rounded" width={'100%'} height={40} />
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 container size={'grow'} flexDirection={'column'} spacing={4}>
                <Grid2 container>
                    <Grid2>
                        <Skeleton variant="rounded" width={300} height={40} />
                    </Grid2>
                    <Grid2 size={'grow'}>
                        <Skeleton variant="rounded" width={'100%'} height={40} />
                    </Grid2>
                </Grid2>
                <Grid2>
                    <Skeleton variant="rounded" width={200} height={20} />
                </Grid2>
                <Divider flexItem sx={{ backgroundColor: t => t.palette.primary.main }} />
                <Grid2 container>
                    <Grid2>
                        <Skeleton variant="rounded" width={200} height={40} />
                    </Grid2>
                    <Grid2 size={'grow'}>
                        <Skeleton variant="rounded" width={'100%'} height={40} />
                    </Grid2>
                </Grid2>
                <Grid2>
                    <Skeleton variant="rounded" width={200} height={20} />
                </Grid2>
                <Divider flexItem sx={{ backgroundColor: t => t.palette.primary.main }} />
                <Grid2 container>
                    <Grid2>
                        <Skeleton variant="rounded" width={250} height={40} />
                    </Grid2>
                    <Grid2 size={'grow'}>
                        <Skeleton variant="rounded" width={'100%'} height={40} />
                    </Grid2>
                </Grid2>
                <Grid2>
                    <Skeleton variant="rounded" width={200} height={20} />
                </Grid2>

                <Grid2 size={'grow'} />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Skeleton variant="rounded" width={100} height={40} />
                    </Grid2>
                    <Grid2>
                        <Skeleton variant="rounded" width={100} height={40} />
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    )
})

export default OrderManageSkeleton